import Loadable from 'react-loadable';

export const ForgeAppsButton = Loadable({
  loader: () => import(/* webpackChunkName: "ForgeAppsButton" */ './ForgeAppsButton'),
  loading: () => null,
});
